import { forwardRef } from "react";
import { cn } from "../../../util/cn";

interface TextAreaProps {
  name: string;
  display: string;
  placeholder?: string;
  readOnly?: boolean;
  maxLength?: number;
  required?: boolean;
  error?: string;
  touched?: boolean;
  reasonHeaderNeeded?:boolean
}

const TextArea = forwardRef(
  (
    {
      name,
      display,
      placeholder = "",
      readOnly = false,
      maxLength = 200,
      required = false,
      reasonHeaderNeeded= true,
      error,
      touched,
      ...props
    }: TextAreaProps,
    ref: any,
  ) => {
    return (
      <div id={name} className="flex-auto">

       

        
     
        <div className="relative mb-4">
          {reasonHeaderNeeded && <p className="mb-2 text-instant-teams-blue-Main ">
          Reason<span className="text-red-500">{required ? " *" : ""}</span>
        </p>}
          <textarea
            name={name}
            placeholder={placeholder}
            readOnly={readOnly}
            maxLength={maxLength}
            ref={ref} // forwarding the ref
            className={cn(
              "form-input shadow-md h-28 bg-gray-100 rounded-md w-full pt-4 pb-3 text-[1rem] text-gray-800 placeholder-gray-400 resize-none",
              {
                "cursor-not-allowed": readOnly,
              },
            )} // Added resize-none to prevent resizing
            {...props}
          />
          <div className=" w-full grid grid-cols-2 gap-2">
            <div>
              {error && (
                <p className={"text-[0.8rem]  font-medium text-[red] "}>
                  {error}
                </p>
              )}
            </div>

            <p className="w-full flex justify-end" >
              {maxLength > 0 && (
                <span className="text-xs text-gray-500">
                  Max {maxLength} characters
                </span>
              )}
            </p>


            {/* Optional success message */}
            {/* {touched && !error && (
            <span className="absolute right-2 top-2 text-xxs">
              <FontAwesomeIcon
                icon={faCircleCheck}
                style={{ color: "green" }}
              />
              {display} looks good!
            </span>
          )} */}


          </div>
        </div>
      </div>
    );
  },
);

TextArea.displayName = "TextArea";

export default TextArea;
